import { createUseStyles } from 'react-jss';
import { Theme } from '@mui/material';

export const useStyles = createUseStyles((theme: Theme) => {
    const { color, radius, font, motion } = theme.custom;
    return {
        toolbar: {
            display: 'flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 16px',
            borderBottom: `1px solid ${color.border}`,
            backgroundColor: color.primary.soft,
            color: color.primary.onSoft,
            fontSize: 13,
            fontWeight: 600,
            flexWrap: 'wrap',
        },
        toolbarActions: { display: 'flex', gap: 8, marginLeft: 'auto', flexWrap: 'wrap' },
        container: { maxHeight: 'calc(100vh - 330px)' },
        mono: { fontFamily: font.mono, fontSize: 13, whiteSpace: 'nowrap' },
        nowrap: { whiteSpace: 'nowrap' },
        thumbButton: {
            position: 'relative',
            width: 48,
            height: 64,
            padding: 0,
            border: 'none',
            borderRadius: radius.sm,
            overflow: 'hidden',
            cursor: 'pointer',
            backgroundColor: color.surfaceMuted,
            display: 'block',
            outline: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'}`,
            outlineOffset: -1,
            transitionProperty: 'transform',
            transitionDuration: motion.fast,
            '&:hover': { transform: 'scale(1.04)' },
            '&:focus-visible': { outline: `2px solid ${color.focusRing}`, outlineOffset: 2 },
            '& img': { width: '100%', height: '100%', objectFit: 'cover', display: 'block' },
        },
        tagCell: {
            cursor: 'pointer',
            minWidth: 110,
            maxWidth: 240,
            '&:hover': { backgroundColor: color.primary.soft },
        },
        tagText: { fontSize: 13, lineHeight: 1.4 },
        tagEmpty: { color: color.text.muted },
        actions: { display: 'flex', gap: 6, justifyContent: 'flex-end', whiteSpace: 'nowrap' },
    };
});
